(ns ycweb.app.website.help.results
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [util.string :as ustr]
   [ycweb.app.website.website :as website]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.help.common :as common]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc help-center-result < rum/reactive [app-atom {:item/keys [body category stats url-name] :as article}]
  (when-not (str/blank? (:ent/display-name article))
    [:article.help-center-result
     [:a
      (merge
        (urlstate/href-props app-atom "help" "article"
          {:id (:stats/contentid stats) :name url-name})
        {:class (u/bem :text-card [:medium] :card :block-link)})

      (headings/heading (:ent/display-name article)
        {:type :h3
         :size :tiny
         :dangerouslySetInnerHTML? true
         :class :help-center-result__title})

      [:p.yc-paragraph.help-center-result__description
       [:span
        {:dangerouslySetInnerHTML
         {:__html (ustr/prune body 145)}}]
       " "
       [:span.text-link "View more."]]
      [:small.help-center-result__category
       (str "In " category)]]]))

(rum/defc help-center-results < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        help-search (cmn/curact process-atom :help-search)
        pagination-atom (rum/cursor-in process-atom [:help-search :help-search/pagination])]
    (web-common/set-meta-title! (str "Yuppiechef Help - FAQs - Search"))
    [:div
     (common/help-center-banner app-atom {})
     (common/breadcrumbs app-atom {})
     [:<>
      [:div
       {:class (u/bem :yc-section [:standard])}
       (headings/heading (str "Search results for \"" (:help-search/searchstr help-search) "\"")
         {:id :search-result-title
          :type :h2
          :size :medium
          :center true})]

      (cond
        (or
          (nil? (:help-search/help-articles help-search))
          (empty? (:help-search/help-articles help-search)))
        [:div
         {:class (u/bem :yc-section [:large])}
         [:div.u-block-center.u-max-width-720.u-text-center
          [:p.yc-paragraph
           (str "Sorry, we could't find any search results for " (:help-search/searchstr help-search) ".")]
          [:p.yc-paragraph
           "Try searching again or go "
           [:a.text-link {:href "/help.htm?action=faqs"} "back to FAQs."]]]]

        :else
        (into
          [:div
           {:class (u/bem :yc-section [(if (> (:help-search/total-pages help-search) 1) :medium :large)])}]
          (concat
            [(map
               (fn [article]
                 (help-center-result app-atom article))
               (:help-search/help-articles help-search))])))

      [:div.flex-grid-group
       [:div
        {:class (u/bem :flex-grid-block [:t-full])}
        [:div.flex-grid-content
         (web-common/pagination-control app-atom pagination-atom
           (:help-search/total-pages help-search)
           {:navigate :url
            :scroll-to "search-result-title"
            :action "search"
            :loading-overlay :web.help/search
            :show-summary? false
            :result-count (:help-search/result-count help-search)})]]]

      (toaster/loading-overlay app-atom :web.help/search)]]))

(defmethod flow/render-screen :web.help/search [app-atom _]
  (website/screen-wrapper app-atom
    (help-center-results app-atom)
    {:pagetype :help
     :hidesearch true}))

(defmethod t/transition-open :web.help/search [app-atom _ {:keys [q page]}]
  (toaster/open-overlay app-atom :web.help/search)
  (comms/ajax-get :web.help/search
    {:help-search
     #:help-search
      {:searchstr q
       :page page}}))

(defmethod comms/receive :web.help/search [app-atom {:keys [help-search]}]
  (let [{:help-search/keys [help-articles searchstr page result-count total-pages] :as search} help-search
        page-number (u/parseInt (or page 1))]
    (swap! (cmn/process-cursor app-atom) assoc
      :help-search
      #:help-search
       {:ent/uuid (:ent/uuid search)
        :searchstr searchstr
        :pagination {:page page-number}
        :result-count result-count
        :total-pages total-pages
        :help-articles help-articles})
    (toaster/close-overlay app-atom :web.help/search)

    (when (> page-number total-pages)
      (urlstate/redirect app-atom "help" "search"
        {:q searchstr
         :page (u/number-format total-pages 0)}))))

(defmethod comms/receive :web.help/category [app-atom {:keys [help-category]}]
  (swap! (cmn/process-cursor app-atom) assoc
    :help-category help-category)
  (toaster/close-overlay app-atom :web.help/category))